var _rect, _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptionCCrossOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "#272727",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7784 12.9375H24.2898C24.2443 12.6155 24.1515 12.3295 24.0114 12.0795C23.8712 11.8258 23.6913 11.6098 23.4716 11.4318C23.2519 11.2538 22.9981 11.1174 22.7102 11.0227C22.4261 10.928 22.1174 10.8807 21.7841 10.8807C21.1818 10.8807 20.6572 11.0303 20.2102 11.3295C19.7633 11.625 19.4167 12.0568 19.1705 12.625C18.9242 13.1894 18.8011 13.875 18.8011 14.6818C18.8011 15.5114 18.9242 16.2083 19.1705 16.7727C19.4205 17.3371 19.7689 17.7633 20.2159 18.0511C20.6629 18.339 21.1799 18.483 21.767 18.483C22.0966 18.483 22.4015 18.4394 22.6818 18.3523C22.9659 18.2652 23.2178 18.1383 23.4375 17.9716C23.6572 17.8011 23.839 17.5947 23.983 17.3523C24.1307 17.1098 24.233 16.8333 24.2898 16.5227L26.7784 16.5341C26.714 17.0682 26.553 17.5833 26.2955 18.0795C26.0417 18.572 25.6989 19.0133 25.267 19.4034C24.839 19.7898 24.3277 20.0966 23.733 20.3239C23.142 20.5473 22.4735 20.6591 21.7273 20.6591C20.6894 20.6591 19.7614 20.4242 18.9432 19.9545C18.1288 19.4848 17.4848 18.8049 17.0114 17.9148C16.5417 17.0246 16.3068 15.947 16.3068 14.6818C16.3068 13.4129 16.5455 12.3333 17.0227 11.4432C17.5 10.553 18.1477 9.875 18.9659 9.40909C19.7841 8.93939 20.7045 8.70455 21.7273 8.70455C22.4015 8.70455 23.0265 8.79924 23.6023 8.98864C24.1818 9.17803 24.6951 9.45455 25.142 9.81818C25.589 10.178 25.9527 10.6193 26.233 11.142C26.517 11.6648 26.6989 12.2633 26.7784 12.9375Z",
    fill: "#272727"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.976197,
    y1: 15.0003,
    x2: 42.9762,
    y2: 14.0003,
    stroke: "#272727",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionCCrossOut);
export default __webpack_public_path__ + "static/media/OptionCCrossOut.d1dd68095e11b62f0c7bb4acdf1fccae.svg";
export { ForwardRef as ReactComponent };